// extracted by mini-css-extract-plugin
module.exports = {"coupon_card":"Coupon_coupon_card__gO8FZ"};